export interface ActionType {
  [key: string]: string
}

export function generatorAsyncTypes(name: string): Array<string> {
  return [`${name}`, `${name}_SUCCESS`, `${name}_FAILURE`];
}

export function createVuexTypes(obj: ActionType, namespace: string = '') {
  let result: ActionType = {};
  const prefix = namespace === '' ? '' : `${namespace}/`;

  Object.entries(obj).forEach(([k, v]) => {
    if (result.hasOwnProperty(k)) {
      throw new Error('存在已定义的 ActionType！');
    }
    if (v === 'async') {
      const [origin, success, failure] = generatorAsyncTypes(k);
      result = {
        ...result,
        [origin]: origin,
        [success]: success,
        [failure]: failure,
      };
    } else {
      result[k] = `${k}`;
    }
  });

  result = Object.keys(result).reduce(
    (p, k) => ({
      ...p,
      [k]: `${prefix}${result[k]}`,
    }),
    {},
  );
  return result;
}
